module.exports = __webpack_public_path__ + "static/media/bg-intro-2112.ad6b8f37.jpg";